'use client';

import type { CSSProperties } from 'react';
import { useTranslations } from 'next-intl';
import { CustomImage } from 'components/shared/custom-image';
import styles from './Reasons.module.css';

type Reason = {
  /** i18n key under `reasons.` in the whyUltrahuman namespace */
  key: string;
  src: string;
  /** object-position for the mobile crop */
  objectPosition: string;
  /** object-position for the desktop (640x400) crop */
  objectPositionDesktop: string;
};

const REASONS: Reason[] = [
  {
    key: 'noSubscription',
    src: 'web_v2/why-uh/01.png',
    objectPosition: '50% 50%',
    objectPositionDesktop: '50% 50%',
  },
  {
    key: 'powerPlugs',
    src: 'web_v2/why-uh/02.png',
    objectPosition: '50% 50%',
    objectPositionDesktop: '50% 50%',
  },
  {
    key: 'jade',
    src: 'web_v2/why-uh/03.png',
    objectPosition: '50% 50%',
    objectPositionDesktop: '50% 50%',
  },
];

export const Reasons = () => {
  const t = useTranslations('whyUltrahuman');

  return (
    <section className={styles.reasonsSection}>
      <div className={styles.reasonsList}>
        {REASONS.map((reason, i) => (
          <div
            key={reason.key}
            className={styles.stickyItem}
            style={{ '--i': i } as CSSProperties}
          >
            <article
              className={
                i === REASONS.length - 1
                  ? `${styles.card} ${styles.cardTop}`
                  : styles.card
              }
            >
              <div className={styles.cardCopy}>
                <h2 className={styles.cardTitle}>
                  {t(`reasons.${reason.key}.title`)}
                </h2>
                <p className={styles.cardSubtitle}>
                  {t(`reasons.${reason.key}.subtitle`)}
                </p>
                <p className={styles.cardBody}>
                  {t(`reasons.${reason.key}.body`)}
                </p>
              </div>
              <div
                className={styles.imageSlot}
                style={
                  {
                    '--object-position': reason.objectPosition,
                    '--object-position-desktop': reason.objectPositionDesktop,
                  } as CSSProperties
                }
              >
                <CustomImage
                  src={reason.src}
                  alt={t(`reasons.${reason.key}.imageAlt`)}
                  fill
                  sizes="(max-width: 992px) 100vw, 640px"
                />
              </div>
            </article>
          </div>
        ))}
      </div>
    </section>
  );
};
